import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">{aboutData.title}</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">了解桃子视频的定位与发展</p>

        <div className="bg-background-100 rounded-lg border border-background-200/60 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">{aboutData.description}</p>

          <div className="grid grid-cols-3 gap-6">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">{stat.value}</div>
                <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}